/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactSlider from 'react-slider';
import classnames from 'classnames';
import TimePickerHour from 'app/components/common/TimePickerHour.jsx';
import TimePickerMinute from 'app/components/common/TimePickerMinute.jsx';
import TimePickerMeridiem from 'app/components/common/TimePickerMeridiem.jsx';
import { Breakpoint } from 'react-socks';

class ScheduleComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			startTime: this.formatTimeForSlider(this.props.schedule.s_startTime),
			endTime: this.formatTimeForSlider(this.props.schedule.s_endTime),
			startClass: this._getStartHandleClass(this.props.schedule.s_startTime, this.props.schedule.s_endTime)
		};

		this.timeToInteger = this.timeToInteger.bind(this);
		this.integerToTime = this.integerToTime.bind(this);
		this.formatTimeForSlider = this.formatTimeForSlider.bind(this);
		this.formatTimeForMobile = this.formatTimeForMobile.bind(this);
		this._sliderUpdate = this._sliderUpdate.bind(this);
		this._getStartHandleClass = this._getStartHandleClass.bind(this);
		this.scheduleUpdate = this.scheduleUpdate.bind(this);
		this.removeSchedule = this.removeSchedule.bind(this);
		this.onMobileStartTimeChange = this.onMobileStartTimeChange.bind(this);
		this.onMobileEndTimeChange = this.onMobileEndTimeChange.bind(this);
		this.onMobileTimeChange = this.onMobileTimeChange.bind(this);

	}

	componentDidMount() {
		this.setState({
			startTime: this.formatTimeForSlider(this.props.schedule.s_startTime),
			endTime: this.formatTimeForSlider(this.props.schedule.s_endTime),
			startClass: this._getStartHandleClass(this.props.schedule.s_startTime, this.props.schedule.s_endTime)
		});
	}

	timeToInteger(time) {
		var parts = time.split(":"),
			integer = 0;

		// special case for midnight
		if (parts[1] === "59") {
			integer = 96;
		} else {
			integer = ((parseInt(parts[0], 10) * 60) + parseInt(parts[1], 10)) / 15;
		}

		return integer;
	}

	integerToTime(segment) {
		var totalMinutes = segment * 15,
			time = "00:00:00",
			minutes = 0;

		minutes = totalMinutes % 60;
		// pad the minutes if necessary
		minutes = (minutes < 10) ? "0" + minutes : minutes;
		time = [Math.floor(totalMinutes / 60), minutes, "00"].join(":");

		return time;
	}

	formatTimeForSlider(time) {
		var date = new Date(),
			timePieces = time.split(":");

		// check that a valid time string was passed in
		// if not, do no harm
		if (timePieces.length != 3) {
			return "";
		}

		date.setHours(timePieces[0]);
		date.setMinutes(timePieces[1]);
		date.setSeconds(timePieces[2]);

		return moment(date).format("hh:mm a");
	}

	formatTimeForMobile(time) {
		var date = new Date(),
			timePieces = time.split(":");

		// check that a valid time string was passed in
		// if not, do no harm
		if (timePieces.length != 3) {
			return "";
		}

		date.setHours(timePieces[0]);
		date.setMinutes(timePieces[1]);
		date.setSeconds(timePieces[2]);

		return moment(date);
	}

	_sliderUpdate(values) {
		var startTime = this.integerToTime(values[0]),
			endTime = this.integerToTime(values[1]);

		this.setState({
			startTime: this.formatTimeForSlider(startTime),
			endTime: this.formatTimeForSlider(endTime),
			startClass: this._getStartHandleClass(startTime, endTime)
		});
	}

	_getStartHandleClass(startTime, endTime) {
		var start = this.timeToInteger(startTime),
			end = this.timeToInteger(endTime);

		return ((end - start) <= 6 && (end - start) > 0) ? 'topper' : '';
	}

	scheduleUpdate(event) {
		var newStart = 0,
			newEnd = 0,
			sched = this.props.schedule,
			day = 0;

		// event isn't an event but a time update from the slider component
		if (event.length !== undefined) {
			newStart = event[0];
			newEnd = event[1];

			// no longer a window, but a single event
			if (newStart === newEnd) {
				newEnd = 0;
			}

			sched.s_startTime = this.integerToTime(newStart);
			sched.s_endTime = this.integerToTime(newEnd);
		} else {
			if (event.currentTarget.dataset.field && event.currentTarget.dataset.field === 'days') {
				day = parseInt(event.currentTarget.dataset.value, 10);
				if (day & parseInt(sched.s_days, 10)) {
					sched.s_days = parseInt(sched.s_days, 10) & ~day;
				} else {
					sched.s_days = parseInt(sched.s_days, 10) | day;
				}
			}
		}

		this.props.updateHandler('update', this.props.schedule);

	}

	removeSchedule() {

		this.props.updateHandler('remove', this.props.schedule);

	}

	onMobileStartTimeChange(value, e) {

		e.persist();
		this.onMobileTimeChange(value, e, 'start');

	}

	onMobileEndTimeChange(value, e) {

		e.persist();
		this.onMobileTimeChange(value, e, 'end');

	}

	onMobileTimeChange(value, e, which) {

		let time = (which === 'start') ? this.props.schedule.s_startTime : this.props.schedule.s_endTime;

		time = this.formatTimeForMobile(time);

        switch (e.target.dataset.field) {
            case "hours":
                time.hour(value);
                break;

            case "minutes":
                time.minute(value);
                break;

            case "meridiem":
                if (time.hour() > 12 && value === 'AM') {
                    time.subtract(12, 'hours');
                } else if (time.hour() < 12 && value === 'PM') {
                    time.add(12, 'hours');
                } else {
                    if (value === 'AM') {
                        time.hour(0);
                    } else {
                        time.hour(12);
                    }
                }
                break;

            default:
                break;
        }

		if (which === 'start') {
			this.props.schedule.s_startTime = time.format('hh:mm:00');
		} else {
			this.props.schedule.s_endTime = time.format('hh:mm:00');
		}

		this.props.updateHandler('update', this.props.schedule);

	}

	render() {
		let constants = this.props.app.config.constants,
			days = [
				{label: 'Sun', value: constants.FS_SUNDAY},
				{label: 'Mon', value: constants.FS_MONDAY},
				{label: 'Tues', value: constants.FS_TUESDAY},
				{label: 'Wed', value: constants.FS_WEDNESDAY},
				{label: 'Thur', value: constants.FS_THURSDAY},
				{label: 'Fri', value: constants.FS_FRIDAY},
				{label: 'Sat', value: constants.FS_SATURDAY},
			],
			scheduleClass = classnames('schedule-control', 'clearfix', {
				'new-schedule': (this.props.schedule.s_id.match !== undefined && this.props.schedule.s_id.match('sch-')) ? true : false
			}),
			startClass = classnames('time-display', this.state.startClass),
			startTime = this.props.schedule.s_startTime,
			endTime = this.props.schedule.s_endTime,
			mobileStart = this.formatTimeForMobile(this.props.schedule.s_startTime),
			mobileEnd = this.formatTimeForMobile(this.props.schedule.s_endTime);

		if (this.props.schedule.s_endTime === "00:00:00") {
			endTime = startTime;
		}

		/*
		<div className="schedule-slider-handle start-handle" data-field="s_startTime">
			<div className={startClass} ref="startTime">{this.state.startTime}</div>
		</div>
		<div className="schedule-slider-handle end-handle" data-field="s_endTime">
			<div className="time-display" ref="endTime">{this.state.endTime}</div>
		</div>
		 */

		return (
			<div className={scheduleClass}>
				<div className="schedule-delete" onClick={this.removeSchedule} role="button" aria-label="remove schedule">
					<i className="fa fa-times-circle"></i>
				</div>
				<div className="day-selector-control">
					{days.map(function(day, i){
						let constants = this.props.app.config.constants,
							selected = (day.value & parseInt(this.props.schedule.s_days, 10)) ? true : false,
							checked = (day.value & parseInt(this.props.schedule.s_days, 10)) ? 'true' : 'false',
							selectorClass = classnames('day-selector', {
								'day-selected': selected
							});

						return (
							<div className={selectorClass} key={i} role="checkbox" aria-checked={checked} data-field="days" data-value={day.value} onClick={this.scheduleUpdate} aria-label="select day">
								{day.label}
							</div>
						);
					}, this)}
				</div>
				<Breakpoint desktop only>
					<div style={{'display': 'flex'}}>
						<ReactSlider
							className="schedule-slider"
							barClassName="schedule-slider-well"
							min={0}
							max={96}
							value={[this.timeToInteger(startTime), this.timeToInteger(endTime)]}
							ariaLabel={['Start Time', 'End Time']}
							onChange={this._sliderUpdate}
							onAfterChange={this.scheduleUpdate}
							trackClassName="schedule-slider-well"
							thumbClassName="schedule-slider-handle"
							pearling
							min-distance={3}
							renderThumb={(props, state) => {
								let dataField = (state.index == 0) ? "s_startTime" : "s_endTime",
									time = (state.index === 0) ? this.state.startTime : this.state.endTime,
									handleClass = (state.index === 0) ? 'start-handle' : 'end_handle',
									timeClass = (state.index === 0) ? startClass : 'time-display',
									{ className } = props;

								return (
									<div {...props} className={`${className} schedule-slider-handle ${handleClass}`} data-field={dataField}>
										<div className={timeClass}>{time}</div>
									</div>
								);
							}}>
						</ReactSlider>
					</div>
					<div className="schedule-slider-keys">
						<div className="slider-key slider-left">
							12 am
						</div>
						<div className="slider-key slider-left six-align">
							6 am
						</div>
						<div className="slider-key">
							12 pm
						</div>
						<div className="slider-key slider-right six-align">
							6 pm
						</div>
						<div className="slider-key slider-right">
							12 am
						</div>
					</div>
				</Breakpoint>
				<Breakpoint mobile only>
					<div className="mobile-schedule-control">
						<div className="time-pickers start">
							<div className="mobile-picker-label">Start checking for updates at:</div>
		                    <TimePickerHour
		                        {...this.props}
		                        changeHandler={this.onMobileStartTimeChange}
		                        scheduleTime={mobileStart}
		                        id={this.props.schedule.s_id}/>
		                    <TimePickerMinute
		                        {...this.props}
		                        changeHandler={this.onMobileStartTimeChange}
		                        scheduleTime={mobileStart}
		                        id={this.props.schedule.s_id}/>
		                    <TimePickerMeridiem
		                        {...this.props}
		                        changeHandler={this.onMobileStartTimeChange}
		                        scheduleTime={mobileStart}
		                        id={this.props.schedule.s_id}/>
		                </div>
						<div className="time-pickers end">
							<div className="mobile-picker-label">Stop checking for updates at:</div>
		                    <TimePickerHour
		                        {...this.props}
		                        changeHandler={this.onMobileEndTimeChange}
		                        scheduleTime={mobileEnd}
		                        id={this.props.schedule.s_id}/>
		                    <TimePickerMinute
		                        {...this.props}
		                        changeHandler={this.onMobileEndTimeChange}
		                        scheduleTime={mobileEnd}
		                        id={this.props.schedule.s_id}/>
		                    <TimePickerMeridiem
		                        {...this.props}
		                        changeHandler={this.onMobileEndTimeChange}
		                        scheduleTime={mobileEnd}
		                        id={this.props.schedule.s_id}/>
		                </div>
					</div>
				</Breakpoint>
			</div>
		);
	}

};

ScheduleComponent.displayName = "ScheduleComponent";

ScheduleComponent.propTypes = {
	schedule: PropTypes.object,
	updateHandler: PropTypes.func
};

ScheduleComponent.defaultProps = {
	schedule: {},
	updateHandler: null
};

export default ScheduleComponent;
